document.addEventListener("DOMContentLoaded", () => {
  initAllHotspotSections()
})

// Handle Shopify section reloads (for duplicating sections)
document.addEventListener("shopify:section:load", (event) => {
  if (event.target.classList.contains("hotspot-section-wrapper")) {
    // Wait a bit for the DOM to be ready
    setTimeout(() => {
      initAllHotspotSections()
    }, 100)
  }
})

// Handle Shopify section reorder
document.addEventListener("shopify:section:reorder", () => {
  setTimeout(() => {
    initAllHotspotSections()
  }, 100)
})

// Handle Shopify section removal
document.addEventListener("shopify:section:remove", (event) => {
  if (event.target.classList.contains("hotspot-section-wrapper")) {
    // Clean up any event listeners or timers for this section
    event.target.removeAttribute("data-hotspot-initialized")
  }
})

function initAllHotspotSections() {
  // Find all hotspot sections and initialize each one
  const allSections = document.querySelectorAll(".hotspot-section-wrapper")
  allSections.forEach((sectionEl) => {
    if (!sectionEl.hasAttribute("data-hotspot-initialized")) {
      initHotspotSection(sectionEl)
      sectionEl.setAttribute("data-hotspot-initialized", "true")
    }
  })
}

function initHotspotSection(sectionRootEl) {
  // If no section element provided, find one
  if (!sectionRootEl) {
    sectionRootEl = document.querySelector(".hotspot-section-wrapper")
  }

  if (!sectionRootEl) return

  const sectionId =
    sectionRootEl.getAttribute("data-section-id") || "hotspot-section"
  const sectionRoot = sectionRootEl
  const mediaContainer = sectionRoot.querySelector(".hotspot-media-container")
  let isDragging = false

  const storageKey = (blockId, device) =>
    `hotspotPos:${sectionId}:${blockId}:${device}`

  // --- Helpers to show % badges above dots in Theme Editor ---
  const isDesign = !!window.Shopify && !!window.Shopify.designMode
  function getOrCreateBadge(point) {
    let badge = point.querySelector(".hotspot-pos-badge")
    if (!badge) {
      badge = document.createElement("span")
      badge.className = "hotspot-pos-badge"
      badge.style.cssText =
        "position:absolute;transform:translate(-50%, calc(-100% - 20px));background:#111;color:#fff;font-size:11px;padding:10px 6px;border-radius:3px;pointer-events:none;z-index:200;white-space:nowrap;"
      point.appendChild(badge)
    }
    return badge
  }
  function showPercentBadge(point) {
    if (!isDesign) return
    const dev = currentDev()
    const K = KFor(dev)
    const top = parseFloat(point.dataset[`top${K}`])
    const left = parseFloat(point.dataset[`left${K}`])
    if (Number.isNaN(top) || Number.isNaN(left)) return
    const badge = getOrCreateBadge(point)
    badge.style.display = "inline-block"
    badge.textContent = `📍 ${top.toFixed(2)}% | ${left.toFixed(2)}%`
    badge.title = `Click to copy position values\nTop: ${top.toFixed(2)}%\nLeft: ${left.toFixed(2)}%`

    // Make badge clickable to copy values
    badge.onclick = () => {
      const text = `Top: ${top.toFixed(2)}%, Left: ${left.toFixed(2)}%`
      navigator.clipboard
        .writeText(text)
        .then(() => {
          badge.textContent = "✅ Copied!"
          setTimeout(() => {
            badge.textContent = `📍 ${top.toFixed(2)}% | ${left.toFixed(2)}%`
          }, 1000)
        })
        .catch(() => {
          badge.textContent = "❌ Copy failed"
          setTimeout(() => {
            badge.textContent = `📍 ${top.toFixed(2)}% | ${left.toFixed(2)}%`
          }, 1000)
        })
    }
  }
  function hidePercentBadge(point) {
    const badge = point.querySelector(".hotspot-pos-badge")
    if (badge) badge.style.display = "none"
  }
  function updateAllBadges() {
    if (!isDesign) return
    getPoints().forEach((p) => showPercentBadge(p))
  }

  function deviceKey() {
    const w = window.innerWidth
    if (w < 768) return "mobile"
    if (w < 1024) return "tablet"
    return "desktop"
  }
  const KFor = (dev) => dev.charAt(0).toUpperCase() + dev.slice(1)
  const currentDev = () => deviceKey()

  function getPoints() {
    return sectionRoot.querySelectorAll(".hotspot-point")
  }
  function getPopups() {
    return sectionRoot.querySelectorAll(".hotspot-popup")
  }

  function hideAllPopups() {
    getPopups().forEach((p) => p.classList.remove("active"))
    getPoints().forEach((pt) => pt.classList.remove("is-active"))
  }

  function normalizeDatasets(point) {
    const p = point

    // Check if we already have valid data for the current device
    const dev = currentDev()
    const K = KFor(dev)
    const hasValidData =
      p.dataset[`top${K}`] &&
      p.dataset[`left${K}`] &&
      p.dataset[`top${K}`] !== "50" &&
      p.dataset[`left${K}`] !== "50"

    if (hasValidData) {
      return
    }

    ;["Desktop", "Tablet", "Mobile"].forEach((K) => {
      // Only set default values if the dataset is completely missing
      // Don't override existing values
      if (p.dataset[`top${K}`] === undefined || p.dataset[`top${K}`] === "") {
        p.dataset[`top${K}`] = "50"
      }
      if (p.dataset[`left${K}`] === undefined || p.dataset[`left${K}`] === "") {
        p.dataset[`left${K}`] = "50"
      }
    })
  }

  function restoreSessionPosition(point) {
    const dev = currentDev()
    const blockId = point.dataset.blockId || "idx"
    const saved = localStorage.getItem(storageKey(blockId, dev))
    if (!saved) return
    try {
      const obj = JSON.parse(saved)
      if (obj && typeof obj.top === "number" && typeof obj.left === "number") {
        const K = KFor(dev)
        // Only restore if the current dataset values are missing or default
        const currentTop = point.dataset[`top${K}`]
        const currentLeft = point.dataset[`left${K}`]

        if (!currentTop || currentTop === "50" || currentTop === "") {
          point.dataset[`top${K}`] = String(obj.top)
        }
        if (!currentLeft || currentLeft === "50" || currentLeft === "") {
          point.dataset[`left${K}`] = String(obj.left)
        }
      }
    } catch (_) {}
  }

  function updatePositions() {
    if (isDragging) return
    const dev = currentDev()
    const K = KFor(dev)
    const points = getPoints()

    points.forEach((p, index) => {
      // Check both dataset and HTML attributes
      const datasetTop = p.dataset[`top${K}`]
      const datasetLeft = p.dataset[`left${K}`]
      const htmlTop = p.getAttribute(`data-top-${dev.toLowerCase()}`)
      const htmlLeft = p.getAttribute(`data-left-${dev.toLowerCase()}`)

      // Use HTML attribute as fallback if dataset is corrupted
      let top = parseFloat(datasetTop)
      let left = parseFloat(datasetLeft)

      if (Number.isNaN(top) && htmlTop) {
        top = parseFloat(htmlTop)
      }
      if (Number.isNaN(left) && htmlLeft) {
        left = parseFloat(htmlLeft)
      }

      // Skip if we don't have valid position data
      if (Number.isNaN(top) || Number.isNaN(left)) {
        return
      }

      // ALWAYS apply the position to ensure it's correct
      const newTop = `${top}%`
      const newLeft = `${left}%`

      // Force the position with !important equivalent
      p.style.setProperty("top", newTop, "important")
      p.style.setProperty("left", newLeft, "important")

      // Also update the dataset to keep it in sync
      p.dataset[`top${K}`] = String(top)
      p.dataset[`left${K}`] = String(left)
    })

    updateAllBadges()
  }

  function positionPopup(point, popup) {
    if (!mediaContainer) return

    // Hide popup temporarily to get accurate dimensions
    popup.style.visibility = "hidden"
    popup.classList.add("active")

    const pr = point.getBoundingClientRect()
    const cr = mediaContainer.getBoundingClientRect()
    const rr = popup.getBoundingClientRect()

    // Remove active class and restore visibility for positioning
    popup.classList.remove("active")
    popup.style.visibility = ""

    const offsetY = 12
    const popupWidth = rr.width
    const popupHeight = rr.height
    const containerWidth = cr.width
    const containerHeight = cr.height

    // Get viewport dimensions for mobile/tablet boundary checking
    const viewportWidth = window.innerWidth
    const viewportHeight = window.innerHeight
    const isMobileOrTablet = window.innerWidth < 1024

    // Calculate initial position (below and centered on the dot)
    let top = pr.top - cr.top + offsetY + pr.height / 2
    let left = pr.left - cr.left + pr.width / 2 - popupWidth / 2

    // Check if popup would go outside container bounds
    const wouldOverflowRight = left + popupWidth > containerWidth
    const wouldOverflowLeft = left < 0
    const wouldOverflowBottom = top + popupHeight > containerHeight
    const wouldOverflowTop = top < 0

    // Enhanced mobile/tablet positioning logic
    if (isMobileOrTablet) {
      // For mobile/tablet, prioritize container boundaries to keep popup within image
      const margin = 20 // Larger margin for mobile/tablet

      // First, check if popup would overflow container bounds and adjust accordingly
      if (wouldOverflowRight) {
        // Popup would overflow right edge of container, position it to the left of the dot
        left = pr.left - cr.left - popupWidth + pr.width / 2
      } else if (wouldOverflowLeft) {
        // Popup would overflow left edge of container, position it to the right of the dot
        left = pr.left - cr.left + pr.width / 2
      }

      if (wouldOverflowBottom) {
        // Popup would overflow bottom edge of container, position it above the dot
        top = pr.top - cr.top - popupHeight - offsetY + pr.height / 2
        // Add spacing when popup is above the dot
        top = top - 16
      } else if (wouldOverflowTop) {
        // Popup would overflow top edge of container, position it below the dot
        top = pr.top - cr.top + offsetY + pr.height / 2
      }

      // Ensure popup stays within container bounds first
      top = Math.max(0, Math.min(top, containerHeight - popupHeight))
      left = Math.max(0, Math.min(left, containerWidth - popupWidth))

      // Then check viewport boundaries as a secondary constraint
      const popupRightEdge = left + popupWidth
      const popupLeftEdge = left
      const popupBottomEdge = top + popupHeight
      const popupTopEdge = top

      // If popup still overflows viewport, adjust within container bounds
      // But try to keep it as close to the dot as possible
      if (popupRightEdge > viewportWidth - margin) {
        // Try to position to the left of the dot first, but stay within container
        const leftOfDot = pr.left - cr.left - popupWidth + pr.width / 2
        if (leftOfDot >= 0) {
          left = leftOfDot
        } else {
          // If that doesn't work, use viewport constraint but stay within container
          left = Math.max(
            0,
            Math.min(
              containerWidth - popupWidth,
              viewportWidth - popupWidth - margin,
            ),
          )
        }
      }
      if (popupLeftEdge < margin) {
        // Try to position to the right of the dot first, but stay within container
        const rightOfDot = pr.left - cr.left + pr.width / 2
        if (rightOfDot + popupWidth <= containerWidth) {
          left = rightOfDot
        } else {
          // If that doesn't work, use viewport constraint but stay within container
          left = Math.min(containerWidth - popupWidth, margin)
        }
      }
      if (popupBottomEdge > viewportHeight - margin) {
        // Try to position above the dot first, but stay within container
        const aboveDot =
          pr.top - cr.top - popupHeight - offsetY + pr.height / 2 - 16
        if (aboveDot >= 0) {
          top = aboveDot
        } else {
          // If that doesn't work, use viewport constraint but stay within container
          top = Math.max(
            0,
            Math.min(
              containerHeight - popupHeight,
              viewportHeight - popupHeight - margin,
            ),
          )
        }
      }
      if (popupTopEdge < margin) {
        // Try to position below the dot first, but stay within container
        const belowDot = pr.top - cr.top + offsetY + pr.height / 2
        if (belowDot + popupHeight <= containerHeight) {
          top = belowDot
        } else {
          // If that doesn't work, use viewport constraint but stay within container
          top = Math.min(containerHeight - popupHeight, margin)
        }
      }

      // Final container bounds check
      top = Math.max(0, Math.min(top, containerHeight - popupHeight))
      left = Math.max(0, Math.min(left, containerWidth - popupWidth))
    } else {
      // Desktop positioning logic
      if (wouldOverflowRight) {
        // Popup would overflow right, position it to the left of the dot
        left = pr.left - cr.left - popupWidth + pr.width / 2
      }

      if (wouldOverflowLeft) {
        // Popup would overflow left, position it to the right of the dot
        left = pr.left - cr.left + pr.width / 2
      }

      if (wouldOverflowBottom) {
        // Popup would overflow bottom, position it above the dot
        top = pr.top - cr.top - popupHeight - offsetY + pr.height / 2
        // Add spacing when popup is above the dot
        top = top - 16
      }

      if (wouldOverflowTop) {
        // Popup would overflow top, position it below the dot
        top = pr.top - cr.top + offsetY + pr.height / 2
      }
    }

    // Final bounds checking to ensure popup stays within container
    top = Math.max(0, Math.min(top, containerHeight - popupHeight))
    left = Math.max(0, Math.min(left, containerWidth - popupWidth))

    // On mobile/tablet, aggressively ensure popup stays within viewport
    if (isMobileOrTablet) {
      // Force popup to stay within viewport bounds with proper margins
      const margin = 20 // Larger margin for mobile/tablet

      // Final safety check - ensure popup is always within viewport bounds
      left = Math.max(
        margin,
        Math.min(left, viewportWidth - popupWidth - margin),
      )
      top = Math.max(
        margin,
        Math.min(top, viewportHeight - popupHeight - margin),
      )

      // If popup still can't fit properly, force it to center over the dot within viewport
      if (
        left < margin ||
        left + popupWidth > viewportWidth - margin ||
        top < margin ||
        top + popupHeight > viewportHeight - margin
      ) {
        // Instead of centering over the dot, try to position it as close to the dot as possible
        // while staying within both container and viewport bounds

        // Try to position relative to the dot first
        let newLeft = pr.left - cr.left - popupWidth / 2 + pr.width / 2
        let newTop = pr.top - cr.top - popupHeight / 2 + pr.height / 2

        // Ensure it's within container bounds
        newLeft = Math.max(0, Math.min(newLeft, containerWidth - popupWidth))
        newTop = Math.max(0, Math.min(newTop, containerHeight - popupHeight))

        // Then adjust for viewport if needed, but try to stay close to the dot
        if (newLeft < margin) {
          newLeft = margin
        } else if (newLeft + popupWidth > viewportWidth - margin) {
          newLeft = viewportWidth - popupWidth - margin
        }

        if (newTop < margin) {
          newTop = margin
        } else if (newTop + popupHeight > viewportHeight - margin) {
          newTop = viewportHeight - popupHeight - margin
        }

        // Final container bounds check
        newLeft = Math.max(0, Math.min(newLeft, containerWidth - popupWidth))
        newTop = Math.max(0, Math.min(newTop, containerHeight - popupHeight))

        // Only use the new position if it's actually better (closer to the dot)
        const currentDistance = Math.sqrt(
          Math.pow(left - (pr.left - cr.left), 2) +
            Math.pow(top - (pr.top - cr.top), 2),
        )
        const newDistance = Math.sqrt(
          Math.pow(newLeft - (pr.left - cr.left), 2) +
            Math.pow(newTop - (pr.top - cr.top), 2),
        )

        if (newDistance < currentDistance) {
          left = newLeft
          top = newTop
        }
      }
    }

    // Check if popup is positioned over the dot
    const isOverDot =
      top < 0 ||
      top + popupHeight > containerHeight ||
      left < 0 ||
      left + popupWidth > containerWidth

    // If popup still can't fit properly, try to reposition it around the dot instead of centering
    if (isOverDot) {
      // Try to find a better position around the dot first
      let betterPositionFound = false

      // Try positioning above the dot
      let newTop = pr.top - cr.top - popupHeight - offsetY + pr.height / 2 - 16
      let newLeft = pr.left - cr.left + pr.width / 2 - popupWidth / 2

      if (
        newTop >= 0 &&
        newTop + popupHeight <= containerHeight &&
        newLeft >= 0 &&
        newLeft + popupWidth <= containerWidth
      ) {
        top = newTop
        left = newLeft
        betterPositionFound = true
      }

      // If above doesn't work, try below
      if (!betterPositionFound) {
        newTop = pr.top - cr.top + offsetY + pr.height / 2
        if (
          newTop >= 0 &&
          newTop + popupHeight <= containerHeight &&
          newLeft >= 0 &&
          newLeft + popupWidth <= containerWidth
        ) {
          top = newTop
          left = newLeft
          betterPositionFound = true
        }
      }

      // If neither above nor below works, try left of dot
      if (!betterPositionFound) {
        newLeft = pr.left - cr.left - popupWidth + pr.width / 2
        newTop = pr.top - cr.top + pr.height / 2 - popupHeight / 2
        if (
          newTop >= 0 &&
          newTop + popupHeight <= containerHeight &&
          newLeft >= 0 &&
          newLeft + popupWidth <= containerWidth
        ) {
          top = newTop
          left = newLeft
          betterPositionFound = true
        }
      }

      // If left doesn't work, try right of dot
      if (!betterPositionFound) {
        newLeft = pr.left - cr.left + pr.width / 2
        if (
          newTop >= 0 &&
          newTop + popupHeight <= containerHeight &&
          newLeft >= 0 &&
          newLeft + popupWidth <= containerWidth
        ) {
          top = newTop
          left = newLeft
          betterPositionFound = true
        }
      }

      // Only if no better position is found, center over the dot as last resort
      if (!betterPositionFound) {
        top = pr.top - cr.top - popupHeight / 2 + pr.height / 2
        left = pr.left - cr.left - popupWidth / 2 + pr.width / 2
      }

      // Ensure it's still within bounds
      top = Math.max(0, Math.min(top, containerHeight - popupHeight))
      left = Math.max(0, Math.min(left, containerWidth - popupWidth))

      // On mobile/tablet, also ensure it stays within viewport
      if (isMobileOrTablet) {
        // Only adjust for viewport if it doesn't break container boundaries
        if (top + popupHeight > viewportHeight - 10) {
          top = Math.max(0, viewportHeight - popupHeight - 10)
        }
        if (left + popupWidth > viewportWidth - 10) {
          left = Math.max(0, viewportWidth - popupWidth - 10)
        }
        if (top < 10) {
          top = Math.min(containerHeight - popupHeight, 10)
        }
        if (left < 10) {
          left = Math.min(containerWidth - popupWidth, 10)
        }

        // Final container bounds check
        top = Math.max(0, Math.min(top, containerHeight - popupHeight))
        left = Math.max(0, Math.min(left, containerWidth - popupWidth))
      }
    }

    // Apply final position
    popup.style.top = `${top}px`
    popup.style.left = `${left}px`

    // Add/remove over-dot class for styling
    if (isOverDot) {
      popup.classList.add("over-dot")
    } else {
      popup.classList.remove("over-dot")
    }
  }

  function bindInteractions(point) {
    normalizeDatasets(point)
    restoreSessionPosition(point)

    const id = point.dataset.hotspotId
    const popup = sectionRoot.querySelector(
      "#" + (window.CSS && CSS.escape ? CSS.escape(id) : id),
    )
    if (!popup) return

    point.addEventListener("click", (e) => {
      e.stopPropagation()
      if (window.innerWidth < 1024) {
        const active = popup.classList.contains("active")
        hideAllPopups()
        if (!active) {
          positionPopup(point, popup)
          popup.classList.add("active")
          point.classList.add("is-active")
        }
      }
    })
    point.addEventListener("mouseenter", () => {
      if (window.innerWidth >= 1024) {
        hideAllPopups()
        positionPopup(point, popup)
        popup.classList.add("active")
        point.classList.add("is-active")
      }
    })

    // Add mouseenter event to popup to keep it open when hovering over content
    popup.addEventListener("mouseenter", () => {
      if (window.innerWidth >= 1024) {
        // Keep popup open when hovering over it
        popup.classList.add("active")
        point.classList.add("is-active")
      }
    })

    // Only close popup when mouse leaves both the point AND the popup
    let popupTimeout
    point.addEventListener("mouseleave", () => {
      if (window.innerWidth >= 1024) {
        // Add small delay to allow moving mouse to popup
        popupTimeout = setTimeout(() => {
          // Check if mouse is over popup before closing
          if (!popup.matches(":hover")) {
            popup.classList.remove("active")
            point.classList.remove("is-active")
          }
        }, 100)
      }
    })

    popup.addEventListener("mouseleave", () => {
      if (window.innerWidth >= 1024) {
        // Clear timeout and close popup
        if (popupTimeout) {
          clearTimeout(popupTimeout)
        }
        popup.classList.remove("active")
        point.classList.remove("is-active")
      }
    })
    showPercentBadge(point)
  }

  // Drag support (Theme Editor only) – Pointer Events, supports new points
  function bindDrag(point) {
    if (!isDesign || !mediaContainer) return
    const blockId = point.dataset.blockId || "idx"
    const badge = getOrCreateBadge(point)

    let pointerActive = false
    let didDrag = false

    const updateFromXY = (x, y) => {
      const cr = mediaContainer.getBoundingClientRect()
      let leftPct = ((x - cr.left) / cr.width) * 100
      let topPct = ((y - cr.top) / cr.height) * 100
      leftPct = Math.max(0, Math.min(100, leftPct))
      topPct = Math.max(0, Math.min(100, topPct))
      point.style.left = `${leftPct}%`
      point.style.top = `${topPct}%`
      showPercentBadge(point)

      // Update the data attributes for the position fields
      const dev = currentDev()
      const K = KFor(dev)
      point.dataset[`top${K}`] = String(topPct.toFixed(2))
      point.dataset[`left${K}`] = String(leftPct.toFixed(2))
    }

    point.addEventListener(
      "pointerdown",
      (ev) => {
        if (ev.button !== 0) return
        isDragging = true
        pointerActive = true
        didDrag = false
        hideAllPopups()
        try {
          point.setPointerCapture(ev.pointerId)
        } catch (_) {}
        updateFromXY(ev.clientX, ev.clientY)
        ev.preventDefault()
        ev.stopPropagation()
      },
      { passive: false },
    )

    point.addEventListener(
      "pointermove",
      (ev) => {
        if (!pointerActive) return
        didDrag = true
        updateFromXY(ev.clientX, ev.clientY)
        ev.preventDefault()
        ev.stopPropagation()
      },
      { passive: false },
    )

    const endPointer = (ev) => {
      if (!pointerActive) return
      pointerActive = false
      isDragging = false
      const dev = currentDev()
      const K = KFor(dev)
      const topPct = parseFloat(point.style.top)
      const leftPct = parseFloat(point.style.left)
      point.dataset[`top${K}`] = String(topPct.toFixed(2))
      point.dataset[`left${K}`] = String(leftPct.toFixed(2))
      try {
        localStorage.setItem(
          storageKey(blockId, dev),
          JSON.stringify({ top: topPct, left: leftPct }),
        )
      } catch (_) {}

      // Note: Shopify doesn't allow direct form field manipulation
      // Instead, we show position values in badges and save to localStorage

      updatePositions()
      showPercentBadge(point)
      if (didDrag)
        point.addEventListener("click", (e) => e.preventDefault(), {
          once: true,
        })
      ev.preventDefault()
      ev.stopPropagation()
    }

    point.addEventListener("pointerup", endPointer)
    point.addEventListener("pointercancel", endPointer)
  }

  function initExistingPoints() {
    getPoints().forEach((p) => normalizeDatasets(p))
    getPoints().forEach((p) => {
      bindInteractions(p)
    })
    updatePositions()
    updateAllBadges()
    getPoints().forEach((p) => bindDrag(p))

    // Force update positions after a short delay to handle theme editor
    if (isDesign) {
      setTimeout(() => {
        updatePositions()
        updateAllBadges()
        // Ensure all points are visible and properly positioned
        getPoints().forEach((point) => {
          point.style.display = "block"
          point.style.visibility = "visible"
          point.style.opacity = "1"

          // Force correct positioning
          const dev = currentDev()
          const K = KFor(dev)
          const top = point.dataset[`top${K}`]
          const left = point.dataset[`left${K}`]

          if (top && left) {
            point.style.setProperty("top", `${top}%`, "important")
            point.style.setProperty("left", `${left}%`, "important")
          }
        })
      }, 100)
    }
  }

  // Observe for new points added by Theme Editor (block add/duplicate)
  if (mediaContainer && "MutationObserver" in window) {
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.matches && node.matches(".hotspot-point")) {
              normalizeDatasets(node)
              restoreSessionPosition(node)
              bindInteractions(node)
              updatePositions()
              bindDrag(node)
              showPercentBadge(node)
            } else {
              const pts = node.querySelectorAll
                ? node.querySelectorAll(".hotspot-point")
                : []
              pts.forEach((p) => {
                normalizeDatasets(p)
                restoreSessionPosition(p)
                bindInteractions(p)
                updatePositions()
                bindDrag(p)
                showPercentBadge(p)
              })
            }
          }
        })
      })

      // Force update positions after any mutation in theme editor
      if (isDesign) {
        setTimeout(() => {
          updatePositions()
          updateAllBadges()
        }, 50)
      }
    })
    mo.observe(sectionRoot, { childList: true, subtree: true })
  }

  document.addEventListener("shopify:section:load", (e) => {
    if (!e || !e.detail) return
    if (e.detail.sectionId === sectionId) {
      setTimeout(() => {
        initExistingPoints()
      }, 50)
    }
  })

  // Handle section select in theme editor
  document.addEventListener("shopify:section:select", (e) => {
    if (!e || !e.detail) return
    if (e.detail.sectionId === sectionId) {
      setTimeout(() => {
        updatePositions()
        updateAllBadges()
        // Ensure dots are visible when section is selected
        getPoints().forEach((point) => {
          point.style.display = "block"
          point.style.visibility = "visible"
          point.style.opacity = "1"
        })
      }, 100)
    }
  })

  // Handle section deselect in theme editor
  document.addEventListener("shopify:section:deselect", (e) => {
    if (!e || !e.detail) return
    if (e.detail.sectionId === sectionId) {
      // Keep dots visible even when section is deselected
      setTimeout(() => {
        getPoints().forEach((point) => {
          point.style.display = "block"
          point.style.visibility = "visible"
          point.style.opacity = "1"
        })
      }, 50)
    }
  })
  document.addEventListener("shopify:block:select", (e) => {
    const id = e && e.detail && e.detail.blockId
    if (!id) return
    const point = sectionRoot.querySelector(
      `.hotspot-point[data-block-id="${id}"]`,
    )
    if (point) {
      normalizeDatasets(point)
      restoreSessionPosition(point)
      bindInteractions(point)
      bindDrag(point)
      updatePositions()
      showPercentBadge(point)
    }
  })
  document.addEventListener("shopify:block:load", (e) => {
    const id = e && e.detail && e.detail.blockId
    if (!id) return
    const point = sectionRoot.querySelector(
      `.hotspot-point[data-block-id="${id}"]`,
    )
    if (point) {
      normalizeDatasets(point)
      restoreSessionPosition(point)
      bindInteractions(point)
      bindDrag(point)
      updatePositions()
      showPercentBadge(point)
    }
  })

  function onInitReady() {
    initExistingPoints()

    // Ensure dots are visible in theme editor
    if (isDesign) {
      // Force show dots after theme editor loads
      setTimeout(() => {
        getPoints().forEach((point) => {
          point.style.display = "block"
          point.style.visibility = "visible"
          point.style.opacity = "1"
        })
        updatePositions()
        updateAllBadges()
      }, 200)

      // Set up continuous monitoring to keep dots visible and positioned correctly
      setInterval(() => {
        getPoints().forEach((point) => {
          if (
            point.style.display === "none" ||
            point.style.visibility === "hidden" ||
            point.style.opacity === "0"
          ) {
            point.style.display = "block"
            point.style.visibility = "visible"
            point.style.opacity = "1"
          }

          // Also check if positions are correct
          const dev = currentDev()
          const K = KFor(dev)
          const expectedTop = point.dataset[`top${K}`]
          const expectedLeft = point.dataset[`left${K}`]

          if (expectedTop && expectedLeft) {
            const currentTop = point.style.top
            const currentLeft = point.style.left
            const expectedTopStyle = `${expectedTop}%`
            const expectedLeftStyle = `${expectedLeft}%`

            if (
              currentTop !== expectedTopStyle ||
              currentLeft !== expectedLeftStyle
            ) {
              point.style.setProperty("top", expectedTopStyle, "important")
              point.style.setProperty("left", expectedLeftStyle, "important")
            }
          }
        })
      }, 1000) // Increased frequency for position monitoring
    }
  }
  const imgs = sectionRoot.querySelectorAll(".hotspot-media img")
  let pending = imgs.length
  if (pending === 0) onInitReady()
  imgs.forEach((img) => {
    if (img.complete) {
      if (--pending === 0) onInitReady()
    } else
      img.addEventListener("load", () => {
        if (--pending === 0) onInitReady()
      })
  })

  const ro = new ResizeObserver(() => updatePositions())
  if (mediaContainer) ro.observe(mediaContainer)
  window.addEventListener("resize", updatePositions)

  // Additional theme editor event handling
  if (isDesign) {
    // Listen for any Shopify theme editor events
    document.addEventListener("shopify:section:reorder", () => {
      setTimeout(() => {
        updatePositions()
        updateAllBadges()
        getPoints().forEach((point) => {
          point.style.display = "block"
          point.style.visibility = "visible"
          point.style.opacity = "1"
        })
      }, 100)
    })

    // Listen for block changes
    document.addEventListener("shopify:block:change", (e) => {
      if (e && e.detail && e.detail.sectionId === sectionId) {
        setTimeout(() => {
          updatePositions()
          updateAllBadges()
          getPoints().forEach((point) => {
            point.style.display = "block"
            point.style.visibility = "visible"
            point.style.opacity = "1"
          })
        }, 100)
      }
    })

    // Preserve positions when form fields are being edited
    document.addEventListener("input", (e) => {
      if (
        e.target &&
        e.target.closest &&
        e.target.closest(".shopify-editor__content")
      ) {
        // A form field is being edited, preserve current positions
        const points = getPoints()
        points.forEach((point) => {
          const dev = currentDev()
          const K = KFor(dev)
          const currentTop = point.style.top
          const currentLeft = point.style.left

          // Convert current CSS positions back to percentages and save them
          if (currentTop && currentLeft) {
            const topMatch = currentTop.match(/(\d+\.?\d*)%/)
            const leftMatch = currentLeft.match(/(\d+\.?\d*)%/)

            if (topMatch && leftMatch) {
              const topValue = parseFloat(topMatch[1])
              const leftValue = parseFloat(leftMatch[1])

              if (!Number.isNaN(topValue) && !Number.isNaN(leftValue)) {
                point.dataset[`top${K}`] = String(topValue)
                point.dataset[`left${K}`] = String(leftValue)
              }
            }
          }
        })
      }
    })
  }

  // Click outside closes popups and clears is-active
  document.addEventListener("click", function (e) {
    const popups = getPopups()
    const points = getPoints()
    if (
      ![...getPopups()].some((p) => p.contains(e.target)) &&
      ![...getPoints()].some((pt) => pt.contains(e.target))
    ) {
      hideAllPopups()
    }
  })
} // Close initHotspotSection function
